import { render, staticRenderFns } from "./latestPressContentItem.vue?vue&type=template&id=fcf63ab8&scoped=true&"
import script from "./latestPressContentItem.vue?vue&type=script&lang=js&"
export * from "./latestPressContentItem.vue?vue&type=script&lang=js&"
import style0 from "./latestPressContentItem.vue?vue&type=style&index=0&id=fcf63ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf63ab8",
  null
  
)

export default component.exports